import { MatchStatus } from '@repo/types';

export const getMatchStatusLabel = (status: MatchStatus) => {
  switch (status) {
    case MatchStatus.HalfTime:
      return { short: 'HT', long: 'Half Time' };
    case MatchStatus.FirstHalfOfExtraTime:
      return { short: 'ET', long: 'Extra Time' };
    case MatchStatus.HalfTimeInExtraTime:
      return { short: 'HT', long: 'Half Time' };
    case MatchStatus.SecondHalfOfExtraTime:
      return { short: 'ET', long: 'Second half of extra time' };
    case MatchStatus.FullTimeAfterExtraTime:
      return { short: 'AET', long: 'After extra time' };
    case MatchStatus.PenaltyShootOut:
      return { short: 'Pens', long: 'Penalties' };
    case MatchStatus.FirstHalf:
      return { short: '1st Half', long: 'First Half' };
    case MatchStatus.SecondHalf:
      return { short: '2nd Half', long: 'Second Half' };
    default:
      return { short: 'FT', long: 'Full Time' };
  }
};
